import {
  ErrorDialogContext,
  errorHandledSync,
} from "@/shared/context/error-context";
import { GetProcessStatusService } from "@/features/accounts/ocr/services/get-process-status-service";
import { PutProcessStatusService } from "@/features/accounts/ocr/services/put-process-status-service";
import { useContext } from "react";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";


export const useProcessStatus = () => {

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  // ローディング用コンテキスト
    const loadingCtx = useContext(LoadingModalContext);

  const getProcessStatusService = new GetProcessStatusService();
  const putProcessStatusService = new PutProcessStatusService();

  /*--------------------
    イベント関連
  --------------------*/
  // OCR読み取り状況取得
  const getProcessStatus = async (
    ocrProcessId: string,
  ) => {
    //loadingCtx.setIsLoading(true);
    try {
      const res = await getProcessStatusService.GetProcessStatus({
        ocr_process_id: ocrProcessId,
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getOcrProcessStatus", error);
    } finally {
      //loadingCtx.setIsLoading(false);
    }
  };

  // OCR読み取り状況更新(完了時)
  const putProcessStatus = async (
    ocrProcessId: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await putProcessStatusService.PutProcessStatus({
        ocr_process_id: ocrProcessId,
        process_status: 5,
      });
    } catch (error) {
      // エラーハンドリング
      console.log("putProcessStatus", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getProcessStatus: errorHandledSync(getProcessStatus, setError),
    putProcessStatus: errorHandledSync(putProcessStatus, setError),
  };
};
